module.exports = __webpack_public_path__ + "img/2-3.ada9e9ea.jpg";